/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FilesInputs */

const en_files = /** @type {(inputs: FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files`)
};

const id_files = /** @type {(inputs: FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

/** @type {(inputs: FilesInputs) => LocalizedString} */
const es_files = en_files;

/** @type {(inputs: FilesInputs) => LocalizedString} */
const fr_files = en_files;

/** @type {(inputs: FilesInputs) => LocalizedString} */
const de_files = en_files;

/** @type {(inputs: FilesInputs) => LocalizedString} */
const ja_files = en_files;

/** @type {(inputs: FilesInputs) => LocalizedString} */
const zh_files = en_files;

/** @type {(inputs: FilesInputs) => LocalizedString} */
const ar_files = en_files;

/** @type {(inputs: FilesInputs) => LocalizedString} */
const it_files = en_files;

/** @type {(inputs: FilesInputs) => LocalizedString} */
const ru_files = en_files;

/** @type {(inputs: FilesInputs) => LocalizedString} */
const pt_files = en_files;

/** @type {(inputs: FilesInputs) => LocalizedString} */
const ko_files = en_files;

/**
* | output |
* | --- |
* | "Files" |
*
* @param {FilesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const files = /** @type {((inputs?: FilesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FilesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_files(inputs)
	if (locale === "es") return es_files(inputs)
	if (locale === "fr") return fr_files(inputs)
	if (locale === "de") return de_files(inputs)
	if (locale === "ja") return ja_files(inputs)
	if (locale === "zh") return zh_files(inputs)
	if (locale === "ar") return ar_files(inputs)
	if (locale === "id") return id_files(inputs)
	if (locale === "it") return it_files(inputs)
	if (locale === "ru") return ru_files(inputs)
	if (locale === "pt") return pt_files(inputs)
	return ko_files(inputs)
});